// The 400s the bundle/company-bundle/approval endpoints return are ACTIONABLE ("A bundle
// with the same modules already exists: ...", "This approval has already been processed"),
// so the server's message has to survive the rejection and reach the admin. `error.message`
// on its own is axios's "Request failed with status code 400", which tells them nothing.
//
// Every api that rejects into a middleware which alerts `action.payload` should reject
// through this, so the alert carries the real reason rather than a guess.
export default function serverMessage(error) {
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }
  return error && error.message;
}
